import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Radio Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Is checked radio
     */
    @Prop({ type: Boolean }) checked!: boolean;

    /**
     * Radio Options
     */
    @Prop({ default: () => [] }) options!: Array<object>;

    /**
     * Port Options to the Groot 1
     * 
     * @deprecated Remove this after refactoring all radio components
     */
    @Prop({ type: Boolean, default: true }) port!: boolean;

    /**
     * Separate Radio and Label
     */
    @Prop({ type: Boolean }) separated!: boolean;

    /**
     * Reverse the label and the Radio
     */
    @Prop({ type: Boolean }) reversed!: boolean;

    /**
     * Inline Radio button
     */
    @Prop({ type: Boolean }) inline!: boolean;
}

export default Props;
